import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import Index from './index';
import Questions from './components/questions';
import ExamsAndAssignments from '../../pages/examsAndAssignments';
import Standards from './components/standards';
import QuestionId from './components/questionId';
import MyContent from './components/myContent';
import {QuestionSearchProvider} from './context';
import { DataProvider } from '../../../assignments/ExamAndAssignmentsContext';

const Main = () => {
  return (
    <QuestionSearchProvider>
      <Routes>
        <Route path="/" element={<Index />}>
          <Route index element={<Navigate to="questions" />} />
          <Route path="/questions" element={<Questions />} />
          <Route path="/exams_assignments/:activityType?" element={<DataProvider><ExamsAndAssignments /></DataProvider>} />
          <Route path="/standards" element={<Standards />} />
          <Route path="/questionId" element={<QuestionId />} />
          <Route path="/mycontent" element={<MyContent />} />
        </Route>
      </Routes>
    </QuestionSearchProvider>
  );
};

export default Main;